export default {
  // Common words
  enter: "Entrer",
  next: "Suivant",
  previous: "Précédent",
  finish: "Terminer",
  returnToWebsite: "Retour au site Web",
  complete: "Compléter",
  submit: "Soumettre",
  cancel: "Annuler",
  yes: "Oui",
  no: "Non",
  skip: "Passer",
  close: "Fermer",
  discard: "Rejeter",
  save: "Enregistrer",
  "thank-you": "Merci",
  select: "Sélectionner",
  hi: "Salut",
  hello: "Bonjour",
  link: "Lien",
  back: "Retour",
  view: "Voir",
  continue: "Continuer",
  of: "de",

  // Client Survey Main
  "client-survey-main-thanks-note":
    "Merci d'avoir pris le temps, vos commentaires façonnent notre offre <br /> pour l'avenir.",
  "client-survey-how-likely-recommend":
    "Quelle est la probabilité que vous nous recommandiez à d'autres ?",
  "client-survey-how-likely-note":
    "Sur une échelle de 0 à 10, où 0 signifie pas du tout probable et 10 extrêmement probable.",
  "client-survey-how-likely-recommend-question":
    "Quelle est la chose que nous pourrions faire pour vous rendre plus susceptible de nous recommander ?",
  "step-of": "Étape {step} sur {total}",
  step: "Étape {step}",
  "client-survey-how-satisfied-with-service":
    "Dans quelle mesure êtes-vous satisfait du service",
  "client-survey-how-satisfied-with-service-question":
    "Quelle est la chose que nous pourrions faire pour nous améliorer ?",
  "client-survey-how-satisfied-with-food":
    "Dans quelle mesure êtes-vous satisfait de la nourriture que vous recevez de notre part ?",
  "client-survey-how-satisfied-with-food-question":
    "Quelle est la chose que nous pourrions faire pour nous améliorer ?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Quelle est la meilleure chose à propos de travailler avec nous ? Veuillez sélectionner tout ce qui compte.",
  "management-team": "Équipe de direction",
  "the-front-line-operations-team": "L'équipe opérationnelle de première ligne",
  "food-offering": "Offre alimentaire",
  innovation: "Innovation",
  communication: "Communication",
  "flexibility-and-responsiveness": "Flexibilité et réactivité",
  billing: "Facturation",
  "health-and-hygiene-standards": "Normes de santé et d'hygiène",
  "if-other-please-specify": "Si autre, veuillez préciser...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Sur la base du service que nous fournissons, où pouvons-nous nous améliorer le plus ? Veuillez sélectionner tout ce qui compte.",
  "please-can-we-have-some-more-detail":
    "Pouvez-vous nous donner plus de détails ?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "Pour nous aider à comprendre vos priorités RSE, veuillez classer par ordre d'importance les éléments suivants :",
  "sustainable-ingredients": "Ingrédients durables",
  "food-waste": "Gaspillage alimentaire",
  "local-sourcing": "Approvisionnement local",
  "people-and-communities": "Personnes &amp; Communautés",
  "energy-reduction": "Réduction d'énergie",
  "working-with-local-communities": "Travailler avec les communautés locales",
  "environmental-choices": "Choix environnementaux",
  "meat-free": "Sans viande",
  "less-plastic": "Moins de plastique",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Souhaitez-vous être contacté au sujet de vos commentaires ? Si oui, veuillez laisser vos coordonnées ci-dessous",
  "full-name": "Nom complet",
  "email-address": "Adresse e-mail",
  "phone-number": "Numéro de téléphone",
  feedback: "Commentaires",
  "view-our-privacy-policy": "Voir notre politique de confidentialité",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Merci d'avoir pris le temps de répondre à l'enquête !",

  // 404 Not Found
  "404-not-found": "404 Non trouvé",

  // Privacy Policy
  "privacy-policy": "Politique de confidentialité",

  // Employee Web Rating Feedback Step 1
  "employee-web-rating-feedback-step-1-positive":
    "Heureux d'apprendre que vous vous sentez positif, nous aimerions savoir pourquoi ?",
  "employee-web-rating-feedback-step-1-negative":
    "Désolé d'apprendre que vous ne vous sentez pas au mieux, pouvez-vous nous dire pourquoi ?",

  // Employee Web Rating Feedback Step 2
  "employee-web-rating-feedback-step-2-heading":
    "Y a-t-il autre chose que vous aimeriez partager avec nous aujourd'hui ?",
  "employee-web-rating-feedback-step-2-information":
    "Avez-vous des commentaires ou des retours sur votre expérience avec nous aujourd'hui ?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Partagez votre expérience avec nous aujourd'hui...",

  // Employee Web Rating Feedback Step 3
  "employee-web-rating-feedback-step-3-heading":
    "Souhaitez-vous féliciter quelqu'un ?",
  "no-employees-found": "Aucun employé trouvé",

  // Employee Web Rating Home
  "choose-location": "Choisir l'emplacement",
  "search-location": "Rechercher un emplacement",
  "feedback-anonymous": "Voulez-vous garder vos commentaires anonymes ?",
  "feedback-feeling-today": "Comment vous sentez-vous aujourd'hui ?",

  // Employee Web Rating Thankyou Page
  "thank-you-for-your-feedback": "Merci pour vos commentaires !",
  "back-to-home": "Retour à l'accueil",
  page: "Page",

  // Feedback Once Alert
  "feedback-once-alert": "Un commentaire a déjà été donné depuis cette URL.",

  // Front Customer Audit
  "please-answer-above-question": "Veuillez répondre à la question ci-dessus.",
  "add-comments": "Ajouter des commentaires",
  "enter-answer": "Entrer la réponse",
  "add-upload-files": "Ajouter des fichiers",

  // Alphega Questions
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Avez-vous acheté des médicaments à la pharmacie aujourd'hui ?",
  "were-you-asked-any-of-the-following":
    "Vous a-t-on posé l'une des questions suivantes :",
  "who-is-the-medicine-for": "Pour qui est le médicament ?",
  "what-are-your-symptoms": "Quels sont vos symptômes ?",
  "how-long-you-had-the-symptoms":
    "Depuis combien de temps avez-vous ces symptômes ?",
  "what-action-you-have-already-taken": "Quelle action avez-vous déjà prise ?",
  "are-you-taking-any-other-medication": "Prenez-vous d'autres médicaments ?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Avez-vous attendu plus de 10 minutes pour être servi ?",
  "were-the-products-you-wanted-in-stock":
    "Étaient-ils les produits que vous vouliez en stock ?",
  "were-the-staff-friendly-and-helpful": "Étaient-ils amicaux et utiles ?",
  "did-you-receive-any-advice-about-your-medicines":
    "Avez-vous reçu des conseils sur vos médicaments ?",

  // Front Mobile Home
  "how-was-your-experience-with-us-today":
    "Comment s'est passée votre expérience avec nous aujourd'hui ?",

  // Front Mobile Thankyou Page
  "thank-you-for-your-time-and-your-answers":
    "Merci pour votre temps et vos réponses.",
  "would-also-like-to-rate-us-on-google":
    "Souhaitez-vous également nous évaluer sur Google ?",
  "rate-us-now": "Évaluez-nous maintenant",

  // Negative Chat Reply
  "select-skill": "Sélectionner une compétence",
  "none-selected": "Aucune sélection",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Pouvons-nous vous contacter au sujet de votre expérience aujourd'hui ?",
  "write-here": "Écrivez ici...",
  "please-can-we-get-your-name": "Pouvons-nous avoir votre nom ?",
  "please-enter-your-email": "Veuillez entrer votre e-mail :",
  "enter-your-phone-number": "Entrez votre numéro de téléphone :",
  "please-tell-us-a-bit-more-about-your-experience":
    "Veuillez nous en dire un peu plus sur votre expérience :",
  "you-have-already-submitted-rating": "Vous avez déjà soumis une évaluation",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Désolé d'apprendre que vous n'avez pas eu la meilleure expérience aujourd'hui avec nous, pourriez-vous nous dire ce qui n'a pas fonctionné ?",

  // Positive Chat Reply
  "select-employee": "Sélectionner un employé",
  "we-d-love-to-know-who-looked-after-you-today":
    "Nous aimerions savoir qui s'est occupé de vous aujourd'hui ?",
  "what-stood-out-to-you-today": "Qu'est-ce qui vous a marqué aujourd'hui ?",
  "did-we-provide-exceptional-service-today":
    "Avons-nous fourni un service exceptionnel aujourd'hui ?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Avez-vous des commentaires ou des retours sur votre expérience avec nous aujourd'hui ?",

  // Client Connect Director
  "message-from-leadership": "Message de la direction",
  "message-from-leadership-text":
    "Je cherche constamment des moyens d'améliorer notre offre pour notre clientèle. Y a-t-il des aspects que nous pourrions améliorer selon vous ?",
  "client-connect-director-another-note":
    "Par ailleurs, si vous souhaitez que notre équipe aborde un sujet spécifique, n'hésitez pas à le partager. Je ne suis pas là seulement pour écouter, mais pour m'engager et agir sur vos préoccupations ou idées.",
  "your-message-here": "Votre message ici",
  "visit-information": "Informations de visite",
  "visit-time-out": "Heure de sortie",
  "contact-information": "Coordonnées",
  "client-connect-director-contact-information-text":
    "Pour vous fournir une assistance améliorée, nous vous demandons vos coordonnées, y compris votre nom, votre adresse e-mail et votre numéro de contact. Ces informations nous permettront de vous répondre rapidement et de vous contacter.",
  name: "Nom",
  "enter-your-name": "Entrez votre nom",
  email: "E-mail",
  "enter-your-email": "Entrez votre e-mail",
  "contact-number": "Numéro de contact",
  "please-enter-your-name": "Veuillez entrer votre nom",
  "please-enter-your-email-or-phone-number":
    "Veuillez entrer votre e-mail ou numéro de téléphone",
  "invalid-email-address": "Adresse e-mail invalide",
  "invalid-phone-number-format":
    "Numéro de téléphone invalide pour le pays sélectionné.",
  "no-match-found": "Aucun résultat",
  "phone-number-must-be-digits-for-country":
    "Le numéro de téléphone doit comporter {count} chiffres pour le pays sélectionné ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Le numéro de téléphone doit comporter entre {min} et {max} chiffres pour le pays sélectionné ({current}/{max}).",
  "please-select-time": "Veuillez sélectionner l'heure",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Vous devez fournir au moins une réponse avant de soumettre l'enquête.",

  // Mobile Survey Questions CheckBoxType
  comment: "Commentaire",
  "comment-is-required": "Le commentaire est requis !",
  "minimum-selection-is": "La sélection minimale est de {min_options}",
  "maximum-selection-is": "La sélection maximale est de {max_options}",
  "this-question-is-required": "Cette question est requise !",
  "please-fill-all-required-grid-rows":
    "Veuillez remplir toutes les lignes requises de la grille !",
  "please-fill-mandatory-fields-to-continue":
    "Veuillez remplir les champs obligatoires pour continuer",

  // Mobile Survey Questions CommentsAndImage
  "please-select-valid-image-files":
    "Veuillez sélectionner des fichiers image valides.",

  // Mobile Survey Questions EmployeeType
  loading: "Chargement",
  "getting-employee": "Récupération de l'employé...",

  // Mobile Survey Questions FileUploadType
  "please-select-valid-image-or-video-files":
    "Veuillez sélectionner des fichiers image ou vidéo valides.",
  "please-select-a-valid-file":
    "Veuillez sélectionner un fichier valide (image, vidéo, PDF ou Word).",

  // Mobile Survey Questions NumberType
  "please-enter-a-number-without-any-decimal-points":
    "Veuillez entrer un nombre sans décimales.",
  "please-enter-a-number-less-than-or-equal-to":
    "Veuillez entrer un nombre inférieur ou égal à {max_number_value}.",

  // Mobile Survey Questions SignatureType
  "please-complete-your-signature": "Veuillez compléter votre signature.",

  // Mobile Survey Questions TextType
  "please-enter-valid-email-address":
    "Veuillez entrer une adresse e-mail valide.",
  "phone-number-should-be-10-digit":
    "Le numéro de téléphone doit comporter 10 chiffres.",
  "please-enter-at-least-characters":
    "Veuillez entrer au moins {minimum_character} caractères.",
  "select-date": "Sélectionner la date",
  "select-time": "Sélectionner l'heure",
  "client-connect-date-picker-aria":
    "Date : {value}. Ouvrir le sélecteur de date",
  "client-connect-time-picker-aria":
    "Heure : {value}. Ouvrir le sélecteur d'heure",
  "select-country": "Sélectionner le pays",

  // Report Page
  "click-the-link-to-see-how": "Cliquez sur le lien pour voir comment.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "En ajoutant vos équipes à la plateforme de reporting ServeFirst, elles peuvent également se connecter pour voir leurs performances ; vous avez également la possibilité de gérer votre équipe et d'accéder à des rapports supplémentaires pour comprendre vos performances globales -",
  "did-you-know": "Le saviez-vous..",
  count: "nombre",
  average: "moyenne",
  focus: "focus",
  performance: "Performance",
  "you-can-create-bespoke-action-plans":
    "Vous pouvez créer des plans d'action sur mesure qui se filtrent directement ici s'ils sont créés dans votre compte ServeFirst, ici vous pouvez créer des actions, des chronologies et des propriétaires instantanément tout en suivant les performances. -",
  "no-of-times-raised": "Nombre de fois soulevé",
  action: "Action",
  "attribute-name": "Nom de l'attribut",
  "action-plan": "Plan d'action",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "En ajoutant vos équipes à la plateforme de reporting ServeFirst, elles peuvent également se connecter pour voir leurs performances ; vous avez également la possibilité de gérer votre équipe et d'accéder à des rapports supplémentaires pour comprendre vos performances globales -",
  result: "Résultat",
  category: "Catégorie",
  "your-location-vs-all-location":
    "Votre emplacement vs. Tous les emplacements",
  "net-promoter-score": "Score Net Promoteur",
  "responses-breakdown": "Répartition des réponses",
  "trended-net-promoter-score": "Score Net Promoteur tendanciel",
  "trended-results": "Résultats tendanciels",
  "net-promoter-score-info":
    "Le Score Net Promoteur est basé sur le % de promoteurs (Score de 5/5) - % de détracteurs (Score de 1, 2 ou 3), vous pouvez en savoir plus sur le Score Net Promoteur en cliquant sur le lien suivant",
  "customer-feedback": "Retour client",
  logan: "Logan",
  "top-performer": "Meilleur performeur",
  "rank-in-the-country": "Rang dans le pays",
  "ytd-score": "Score depuis le début de l'année",
  "score-during-period": "Score pendant la période",
  "0-from-last-month": "0 depuis le mois dernier",
  "total-responses-for-july-2021": "Total des réponses pour juillet 2021",
  promoter: "Promoteur",
  "from-04-sep-2021-to-06-sep-2021": "Du 04 Sep 2021 au 06 Sep 2021",
  "the-focus-currently-is-on": "L'accent est actuellement mis sur",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 client a mentionné cela comme une opportunité.",
  "focus-for-the-month": "Focus du mois",
  "download-pdf": "Télécharger le PDF",

  // Report Page New Report
  "total-responses": "Total des réponses",
  duration: "Durée",
  "customers-have-stated-this-as-an-opportunity":
    "clients ont mentionné cela comme une opportunité",
  "error-fetching-params": "Erreur lors de la récupération des paramètres !",
  "previous-days-was": "Les {days} jours précédents étaient de {score}",

  // Report Page Common LgCard
  "raised-on": "# Soulevé le",
  results: "Résultats",

  // Report Page Components AiSuggestions
  "analyzing-data-please-wait": "Analyse des données, veuillez patienter...",

  // Report Page Components CustomerFeedBack
  "view-report": "Voir le rapport",
  "received-on": "Reçu le",

  // Report Page Components ResponseBreakdown
  detractors: "Détracteurs",
  nps: "NPS",

  // Report Page Components TrendResults
  "trend-results": "Résultats tendanciels",

  // Survey helpers Utils
  "failed-to-fetch-the-pdf-file": "Échec de la récupération du fichier PDF",
  "error-generating-pdf-thumbnail":
    "Erreur lors de la génération de la miniature PDF",
  "error-in-thumbnail-generation-function":
    "Erreur dans la fonction de génération de miniature",
  "failed-to-generate-pdf-thumbnail":
    "Échec de la génération de la miniature PDF",

  // Survey Pages Audition
  "select-audit": "Sélectionner l'audit",

  // Survey Pages ClientConnect
  "select-atleast-min-options": "Sélectionnez au moins {minOptions} options",
  "select-max-options": "Maximum {maxOptions} options autorisées !",
  "error-saving-your-response":
    "Erreur lors de l'enregistrement de votre réponse !",
  "failed-to-load-the-file": "Échec du chargement du fichier !",
  "open-link": "Ouvrir le lien",
  download: "Télécharger",
  details: "Détails",
  title: "Titre",
  description: "Description",
  "general-info": "Informations générales",
  type: "Type",
  size: "Taille",
  "uploaded-by": "Téléchargé par",

  // Survey Pages ClientConnect Intro
  "thank-you-for-your-time": "Merci pour votre temps !",

  // Survey Pages ClientConnect Content
  "review-content": "Examiner le contenu",

  // Survey Pages ClientConnect Survey
  "please-give-us-your-feedback": "Veuillez nous donner vos commentaires",
  "enter-your-response": "Entrez votre réponse",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Bonjour, {name}",
  "client-connect-preview-sent-from": "Envoyé par {sender} - {date}",
  "client-connect-preview-step-of": "Étape {current} sur {total}",
  "client-connect-preview-getting-started": "Premiers pas",
  "client-connect-preview-getting-started-desc":
    "Consultez les ressources de présentation préparées pour vous.",
  "client-connect-preview-share-feedback": "Partagez vos commentaires",
  "client-connect-preview-share-feedback-desc":
    "Vos commentaires nous aident à améliorer votre expérience.",
  "client-connect-preview-talk-leadership": "Échanger avec la direction",
  "client-connect-preview-talk-leadership-desc":
    "Lisez le message de la direction et enregistrez votre réponse.",
  "client-connect-preview-reviewed-these": "J'ai consulté ces éléments",
  "client-connect-preview-send-feedback": "Envoyer les commentaires",
  "client-connect-preview-finish-submit": "Terminer et envoyer",
  "client-connect-preview-save-finish": "Terminer et envoyer",
  "client-connect-preview-your-reply": "Votre réponse",
  "client-connect-preview-saved": "Enregistré",
  "client-connect-preview-edit": "Modifier",
  "client-connect-preview-pop-out": "Ouvrir dans une fenêtre",
  "client-connect-preview-open": "Ouvrir",
  "client-connect-preview-view": "Voir",
  "client-connect-preview-welcome": "Bienvenue",
  "client-connect-preview-feedback": "Commentaires",
  "client-connect-preview-save-message": "Envoyer le message",
  "client-connect-preview-message-footer":
    "Votre message est envoyé directement à l'équipe de direction.",
  "client-connect-preview-leadership-placeholder": "Saisissez votre message...",
  "client-connect-preview-thank-you": "Merci",
  "client-connect-preview-thank-you-body":
    "Vous avez terminé Client Connect. Vos réponses à l'enquête et votre message ont été envoyés à l'équipe — elle vous contactera bientôt.",
  "client-connect-thank-you-message":
    "Merci pour votre temps. Vos commentaires font vraiment la différence.",
  "client-connect-preview-review-answers": "Revoir mes réponses",
  "client-connect-preview-back-dashboard": "Retour au tableau de bord",
  "client-connect-preview-already-submitted":
    "Vos commentaires ont été reçus. Merci ! N'hésitez pas à explorer les documents ci-dessus.",
  "enter-email-address": "Entrer l'adresse e-mail",
  "enter-phone-no": "Entrer le numéro de téléphone",
  "product-type": "Type de produit",
  "enter-number": "Entrez un nombre",
  aspect: "Aspect",

  // Survey Pages ClientConnect Director
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Je cherche constamment des moyens d'améliorer notre offre pour notre clientèle. Y a-t-il des aspects que nous pourrions améliorer selon vous ?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "Par ailleurs, si vous souhaitez que notre équipe aborde un sujet spécifique, n'hésitez pas à le partager. Je ne suis pas là seulement pour écouter, mais pour m'engager et agir sur vos préoccupations ou idées.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "Pour vous fournir une assistance améliorée, nous vous demandons vos coordonnées, y compris votre nom, votre adresse e-mail et votre numéro de contact. Ces informations nous permettront de vous répondre rapidement et de vous contacter.",

  // Survey Pages Location
  "select-the-location-you-visited":
    "Sélectionnez l'emplacement que vous avez visité",
  locations: "Emplacements",
  "is-this-your-current-location": "Est-ce votre emplacement actuel ?",
  "nearest-location": "Emplacement le plus proche",
  "loading-data": "Chargement des données...",
  "please-wait": "Veuillez patienter !",

  // Survey Pages Location Area
  "location-area": "Zone d'emplacement",
  "select-location-area": "Sélectionner la zone d'emplacement",

  // Survey Pages Login
  "please-enter-your-password": "Veuillez entrer votre mot de passe",
  "value-must-be-longer-than-3-characters":
    "La valeur doit comporter plus de 3 caractères",
  "please-enter-your-email-address": "Veuillez entrer votre adresse e-mail",
  password: "Mot de passe",
  "internal-server-error": "Erreur interne du serveur !",
  "sign-in": "Se connecter",

  // Survey Pages SameDaySurvey
  "you-have-already-performed-this-survey":
    "Vous avez déjà répondu à cette enquête !",
  "csat-link-invalid": "Ce lien vers l'enquête n'est plus valide.",

  // Survey Pages SurveyThankYou
  "your-feedback-has-been-submitted":
    "Vos commentaires ont été soumis. Votre numéro de ticket est le #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Un membre de l'équipe vous contactera sous peu.",
  "would-you-also-like-to-rate-us-on-google":
    "Souhaitez-vous également nous évaluer sur Google ?",
  "to-review-our-terms-and-conditions-please-click":
    "Pour consulter nos conditions générales, veuillez cliquer",
  here: "Ici",
  "ticket-number-copied-to-clipboard":
    "Numéro de ticket copié dans le presse-papiers",

  // Survey Pages Welcome
  "visit-date": "Date de visite",
  "visit-time-in": "Heure d'arrivée",
  "please-select-date": "Veuillez sélectionner la date",
  "guest-info": "Informations sur l'invité",
  "please-select-user": "Veuillez sélectionner l'utilisateur",
  "get-started": "Commencer",

  // Survey Pages InventoryType
  "enter-value": "Entrer la valeur",
  "getting-product-list": "Récupération de la liste des produits...",

  // Survey Pages NotesAndImage
  "upload-file": "Télécharger le fichier",

  // Survey Pages NumberType
  "enter-digit": "Entrer un chiffre",

  // Survey Pages TextArea
  "enter-your-comment": "Entrez votre commentaire",

  // Survey Pages Upload
  "file-size-should-be-less-than-10-mb":
    "La taille du fichier doit être inférieure à 10 Mo",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Faites glisser vos fichiers ici, taille de fichier inférieure à 10 Mo ou",
  "upload-or-drag-and-drop-your-files-here":
    "Télécharger ou glisser-déposer vos fichiers ici",
  "browse-files": "Parcourir les fichiers",

  // Survey Pages Questions
  "next-question": "Question suivante",
  "save-and-exit": "Enregistrer et quitter",
  "failed-to-save-and-exit":
    "Impossible d'enregistrer votre progression. Veuillez réessayer.",
  "progress-saved-you-may-close-this-tab":
    "Votre progression a été enregistrée. Vous pouvez maintenant fermer cet onglet.",
  "please-enter-at-least": "Veuillez entrer au moins {min} caractères.",
  "contact-no": "Numéro de contact",
  "please-select-location": "Veuillez sélectionner l'emplacement !",
  "please-select-survey": "Veuillez sélectionner l'enquête !",
  "please-enter-your-email-address-or-phone-number":
    "Veuillez entrer votre adresse e-mail ou numéro de téléphone.",

  // Utils CompressFiles
  "compression-error": "Erreur de compression :",

  // Web Rating FrontLogin
  "enter-location-id": "Entrer l'ID de l'emplacement",
  "invalid-location-id": "ID d'emplacement invalide",
  "location-id-required": "ID d'emplacement requis",

  // Web Rating Index
  "please-tell-us-how-your-experience-was-today":
    "Veuillez nous dire comment s'est passée votre expérience aujourd'hui.",

  // Web Rating Negativefeedback
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Désolé d'apprendre que vous n'avez pas eu la meilleure expérience aujourd'hui avec nous, pourriez-vous nous dire ce qui n'a pas fonctionné ?",
  "enter-valid-email-address": "Entrez une adresse e-mail valide.",
  "can-we-get-in-touch-with-you": "Pouvons-nous vous contacter ?",

  // Web Rating Positivefeedback
  "enter-your-telephone-number": "Entrez votre numéro de téléphone",
  "write-your-feedback": "Écrivez vos commentaires",

  // Web Rating Positivefeedback2
  "what-made-the-employee-name-stand-out-to-you":
    "Qu'est-ce qui a fait que {employeeName} s'est démarqué pour vous ?",
  team: "Équipe",

  // Web Rating PositivefeedbackForm
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Veuillez revenir à l'étape précédente et sélectionner un employé, sans sélection d'employé, il n'est pas possible de soumettre le formulaire de commentaires",
  "share-us-your-experience-with-us-today":
    "Partagez votre expérience avec nous aujourd'hui...",
  "did-employee-name-provide-exceptional-service":
    "{employeeName} a-t-il fourni un service exceptionnel ?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "{employeeName} s'est-il démarqué en fournissant un service exceptionnel ?",

  // Web Rating New apiHelpers loginHelpers
  "please-enter-user-name": "Veuillez entrer le nom d'utilisateur",
  "please-enter-password": "Veuillez entrer le mot de passe",

  // Web Rating New RatingLocations
  search: "Rechercher",
  "select-loction-to-ratings":
    "Sélectionner l'emplacement pour les évaluations",
  location: "Emplacement",
  "is-this-your-location": "Est-ce votre emplacement ?",
  "fetch-details-failed": "Échec de la récupération des détails",

  // Web Rating New PositiveJourny EmployeDetail
  "click-as-many-as-you-want": "Cliquez autant que vous le souhaitez",
  "what-made-employee-name-stand-out-to-you":
    "Qu'est-ce qui a fait que {employeeName} s'est démarqué pour vous ?",
  "what-made-the-team-stand-out-to-you":
    "Qu'est-ce qui a fait que l'équipe s'est démarquée pour vous ?",

  // Web Rating New PositiveJourny EmployeService
  "did-we-stand-out-for-delivering-exceptional-service":
    "Nous sommes-nous démarqués en fournissant un service exceptionnel ?",

  // Web Rating New NegativeJourny EmployePersonalDetail
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Laissez un e-mail ou un numéro de téléphone si vous souhaitez que nous vous contactions, sinon laissez-le vide puis appuyez sur suivant",
  "anything-else-you-d-like-to-share":
    "Autre chose que vous aimeriez partager ?",
  "enter-valid-email": "Entrez un e-mail valide",
  message: "Message",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "En soumettant le formulaire, vous acceptez nos conditions générales et notre politique de confidentialité.",

  // Web Rating New FrontWebLogin
  login: "Connexion",
  username: "Nom d'utilisateur",

  // Web Rating New FrontRating
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Appuyez sur l'expression faciale qui représente le mieux ce que vous ressentez à propos de votre expérience.",
  "getting-employee-list": "Récupération de la liste des employés",
  "getting-skill-data": "Récupération des données de compétences",
  "getting-screen-saver": "Récupération de l'écran de veille",

  // Web Rating New CommonComponents ThankYouModal
  "thank-you-for-contacting-us": "Merci de nous avoir contactés.",
  "we-ll-be-in-touch-very-soon": "Nous vous contacterons très bientôt.",

  // Web Rating New CommonComponents GoogleQrPage
  "you-can-follow-this-button-to-rate-us-on-google":
    "Vous pouvez suivre ce bouton pour nous évaluer sur Google",
  "rate-us-on-google": "Évaluez-nous sur Google",

  // Web Rating New CommonComponents ContactUsModal
  "contact-us": "Contactez-nous",
  "or-you-may-reach-us-on": "...ou vous pouvez nous joindre sur.",
  "do-you-want-to-learn-more-about-serve-first":
    "Voulez-vous en savoir plus sur Serve First ?",

  // Web Rating New CommonComponents BottomBar
  saving: "Enregistrement",
  "please-enter-only-digits-for":
    "Veuillez entrer uniquement des chiffres pour",
  "please-enter": "Veuillez entrer",
  "enter-value-here": "Entrez la valeur ici",

  // Survey Pages Questions Dropdown
  "please-select": "Veuillez sélectionner",
  "survey-retry-message":
    "Vous pourrez effectuer cette enquête après {value} {unit}.",
  minute: "minute",
  minutes: "minutes",
  hour: "heure",
  hours: "heures",
  day: "jour",
  days: "jours",
  week: "semaine",
  weeks: "semaines",
  month: "mois",
  months: "mois",
  clear: "Effacer",

  "powered-by": "Propulsé par",
  "image-is-required": "L'image est requise",
  "please-fill-all-required-contact-information":
    "Veuillez remplir toutes les coordonnées requises",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Veuillez laisser tout commentaire supplémentaire dans la case ci-dessous.",
  "all-feedback-is-confidential": "Tous les commentaires sont confidentiels",
  "your-feedback-has-been-received-thank-you":
    "Vos commentaires ont été reçus, merci",
  "close-page": "Fermer la page",
  send: "Envoyer",
  sending: "Envoi",
  "enter-your-feedback-here": "Entrez votre feedback ici",
  "for-anything-else-please": "Pour tout autre commentaire, veuillez ",
  "please-correct-the-custom-field-values":
    "Veuillez corriger les valeurs des champs personnalisés",
  "please-complete-all-required-contact-information":
    "Veuillez remplir toutes les coordonnées requises",
  "survey-cannot-be-submitted": "La enquête ne peut pas être soumise",
  "please-enter-your-phone": "Veuillez entrer votre numéro de téléphone",
  "network-error-please-try-again":
    "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
  "no-results-found": "Aucun résultat trouvé",
  "drop-files-here": "Déposez les fichiers ici...",
  "drag-drop-files":
    "Glissez-déposez des fichiers ici, ou cliquez pour sélectionner des fichiers",
  "max-5-files-5mb": "Max 5 fichiers, 5 Mo chacun, images uniquement",
  remove: "Supprimer",

  // Learning & Development

  "ld-module-title": "Formation et développement",
  "ld-no-sign-in-required": "Connexion non requise",
  "ld-progress-warning":
    "Veuillez ne pas fermer cette fenêtre — votre progression n'est pas enregistrée et vous devrez recommencer.",
  "ld-loading-module": "Chargement du module de formation…",
  "ld-unable-load-module": "Impossible de charger le module de formation.",
  "ld-package-not-configured": "Le package de formation n'est pas configuré.",
  "ld-start-guidance": "Commencer la formation",
  "ld-due-date": "Échéance {date}",
  "ld-whats-involved": "Ce qui est prévu",
  "ld-your-progress": "VOTRE PROGRESSION",
  "ld-step-of": "Étape {current} sur {total}",
  "ld-watched-in-full": "Visionné en entier",
  "ld-video-no-skip": "Vous pouvez revenir en arrière, mais pas avancer",
  "ld-video-muted-counts": "Muet — la lecture compte toujours",
  "ld-maximize-document": "Agrandir le document",
  "ld-minimize-document": "Réduire le document",
  "ld-read-percent": "{percent} % lu",
  "ld-end-of-document": "Fin du document",
  "ld-scroll-to-continue": "Faites défiler pour continuer",
  "ld-read-to-end": "Lu jusqu'à la fin",
  "ld-read-to-end-to-continue": "Lisez jusqu'à la fin pour continuer",
  "ld-loading-document": "Chargement du document…",
  "ld-pdf-preview-unavailable":
    "Impossible d'afficher ce PDF dans le navigateur.",
  "ld-pdf-page-alt": "{title} — page {page}",
  "ld-knowledge-check": "TEST DE CONNAISSANCES",
  "ld-knowledge-check-title": "{title} — test de connaissances",
  "ld-quiz-instruction":
    "Répondez à {count, plural, one {# question} other {# questions}}. Note de passage {passMark} %.",
  "ld-quiz-instruction-pass-only": "Note de passage {passMark} %.",
  "ld-question-of": "QUESTION {current} SUR {total}",
  "ld-guidance-of": "FORMATION {current} SUR {total}",
  "ld-loading-questionnaire": "Chargement du questionnaire…",
  "ld-preparing-questions": "Préparation de vos questions",
  "ld-submit-answers": "Envoyer les réponses",
  "ld-submitting": "Envoi en cours…",
  "ld-ready-to-submit": "Prêt à envoyer vos réponses",
  "ld-answer-selected": "Réponse sélectionnée",
  "ld-select-answer": "Sélectionnez une réponse pour continuer",
  "ld-pass-mark-note":
    "Vous devez obtenir {passMark} % ou plus pour réussir. Les réponses ne peuvent pas être modifiées après envoi.",
  "ld-questionnaire-not-configured": "Le questionnaire n'est pas configuré.",
  "ld-unable-load-questionnaire": "Impossible de charger le questionnaire.",
  "ld-no-visible-questions":
    "Aucune question n'est disponible pour ce contrôle de connaissances pour le moment.",
  "ld-unable-submit-answers":
    "Impossible d'envoyer les réponses. Veuillez réessayer.",
  "ld-not-passed": "Non réussi",
  "ld-completed": "Terminé",
  "ld-fail-title": "Vous y êtes presque — réessayez",
  "ld-fail-description":
    "Vous avez obtenu {score} — la note de passage est de {passMark} %. Il vous reste {remaining}.",
  "ld-attempts-remaining":
    "{count, plural, one {# tentative} other {# tentatives}}",
  "ld-attempt-of": "Tentative {current} sur {total}",
  "ld-fail-alert":
    "Prenez le temps de relire le guide, puis repassez le test. Après votre dernière tentative, le test sera verrouillé.",
  "ld-try-again": "Réessayer",
  "ld-review-guidance": "Revoir le guide",
  "ld-locked-title": "Cette formation est maintenant verrouillée",
  "ld-locked-description":
    "Vous avez obtenu {score} — la note de passage pour ce package est de {passMark} %. Pour des raisons de conformité, vous ne pouvez pas le repasser ici.",
  "ld-speak-to-manager": "Parlez à votre responsable",
  "ld-locked-manager-copy":
    "Votre responsable peut réattribuer {courseTitle} afin que vous puissiez revoir le guide et repasser le test.",
  "ld-close-window": "Vous pouvez maintenant fermer cette fenêtre.",
  "ld-close-window-safe":
    "Vous pouvez maintenant fermer cette fenêtre en toute sécurité.",
  "ld-success-title": "Félicitations !",
  "ld-success-description":
    "Vous avez terminé {courseTitle} avec succès. Cela a été enregistré dans votre profil de formation — vous n'avez plus rien à faire.",
  "ld-email-yourself": "Recevoir une copie par e-mail",
  "ld-email-copy-description":
    "Envoyez une confirmation de complétion dans votre boîte de réception pour vos archives.",
  "ld-email-placeholder": "vous@entreprise.com",
  "ld-sent": "Envoyé",
  "ld-sending-email": "Envoi en cours…",
  "ld-unable-send-email": "Impossible d'envoyer l'e-mail. Veuillez réessayer.",
  "ld-email-sent-success": "E-mail de confirmation envoyé avec succès !",
  "ld-video-briefing": "Briefing vidéo",
  "ld-document": "Document",
  "ld-video-meta": "Vidéo",
  "ld-video-meta-no-skip": "Vidéo · pas d'avance rapide",
  "ld-document-meta": "Document · PDF",
  "ld-document-meta-scroll": "Document · PDF · faire défiler jusqu'à la fin",
  "ld-video-instruction-full":
    "Regardez en entier — vous ne pouvez pas avancer",
  "ld-video-instruction": "Regardez le briefing, puis continuez",
  "ld-document-instruction-scroll":
    "Faites défiler jusqu'à la fin pour continuer",
  "ld-document-instruction": "Consultez le document, puis continuez",
  "ld-questionnaire": "Questionnaire",
  "ld-confirmation": "Confirmation",
  "ld-question-count": "{count, plural, one {# question} other {# questions}}",
  "ld-knowledge-check-subtitle": "Test de connaissances",
  "ld-score": "Score",
  "ld-whats-involved-pass-mark":
    "Note de passage {passMark} % · débloqué après le guide",
  "ld-document-type-pdf": "{documentType} · PDF",
};
